module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAMAAACeyVWkAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAE5QTFRFAAAA9TkN9TkN9TkN9TkN9TkN9TkN9TkN9TkN9TkN+G5O9lMt9TkN+qOO/vLv////+pV+/uXf+Hte9TkN9kYd9TkN92E9+Yhu/Mq+/dfPpd8LLgAAABp0Uk5TAGCfz/9fUN+Qj///4P///////6D/0P////+W7q/KAAAAlklEQVR4nH2Q2xLCIAxEsUSKBRIsgvr/P6rc0oyj7tNyZslNqX86LRpAL2fJzApDq2FoQejyDQLY/n28ts1104r4ZgMSUei1a/ceiNcQkfYZTp3eap5i80mpzG0KUq+slWJ4J9yHFRSxAFOu8AjTZe4mlXgycPic1PAWUAgH9HLj4kT0x3U+sOUDGz+ZP65eeXrPndNgL8koCBnrHZYuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-simbol.png
// module id = Uf39
// module chunks = 1